import { Injectable } from '@angular/core';
import { GetAlertSuspendStatusRequest } from 'emr-ng-shared';

@Injectable()
export abstract class AlertSuppressionPopup {
    abstract OpenAlertSuppressionPopup(alertSuspendStatusRequest?: GetAlertSuspendStatusRequest): void;
}

